import React, { FC } from 'react';
import styled from '@emotion/styled';
import { Box } from '~Styles';
import Icon from '~ComponentsImproved/Icon';
import Help from '~Assets/icons/help.svg';
import Add from '~Assets/icons/add.svg';
import Remove from '~Assets/icons/remove.svg';
import Heading from '~ComponentsImproved/Typography/Heading';
import Paragraph from '~ComponentsImproved/Typography/Paragraph';
import BackTopBar from '~ComponentsImproved/BackTopBar';
import { useI18n, useButton } from '~Hooks';
import useModal from '~ComponentsImproved/Modal/useModal';

import Modal from '~ComponentsImproved/Modal';
import { ModalContent } from '~Styles/modal';

const ScoreInfoButton = styled(Box)`
  margin-right: 8px;
  gap: 8px;
`;

const VerticalDivider = styled.div`
  width: 1px;
  background-color: var(--colorBlueGray1100);
  margin: 0 16px;
`;

const IconWrapper = styled(Box)`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const TopBar: FC = () => {
  const scoreInfoModal = useModal();
  const { i18n } = useI18n();

  const scoreInfoButton = useButton({
    onClick: scoreInfoModal.toggle,
  });

  return (
    <>
      <BackTopBar title={i18n('Competitions.Title')} dark>
        <ScoreInfoButton
          display="flex"
          alignItems="center"
          justifyContent="center"
          {...scoreInfoButton}>
          <Paragraph level={4} color="var(--colorBlueGray200)">
            {i18n('Competitions.ScoreInfo')}
          </Paragraph>
          <Icon src={Help} color="var(--colorBlueGray200)" width="24px" height="24px" />
        </ScoreInfoButton>
      </BackTopBar>

      <Modal isShowing={scoreInfoModal.isShowing} hide={scoreInfoModal.toggle}>
        <ModalContent>
          <Box display="flex" flexDirection="column" gap="small" padding="large">
            <Heading level={2} color="var(--colorWhite)">
              {i18n('Competitions.ScoreInfo')}
            </Heading>
            <Paragraph level={3} color="var(--colorBlueGray200)">
              {i18n('Competitions.ScoreInfo.Desc')}
            </Paragraph>
          </Box>

          <Box display="flex" justifyContent="space-between" padding="large">
            <Box display="flex" flexDirection="column" gap="small">
              <Box display="flex" alignItems="center" gap="xs">
                <IconWrapper>
                  <Icon src={Add} color="var(--colorUIGreen)" />
                </IconWrapper>
                <Paragraph level={4} color="var(--colorBlueGray200)">
                  {i18n('Competitions.ScoreInfo.Add.SaleInPos')}
                </Paragraph>
              </Box>

              <Box display="flex" alignItems="center" gap="xs">
                <IconWrapper>
                  <Icon src={Add} color="var(--colorUIGreen)" />
                </IconWrapper>
                <Paragraph level={4} color="var(--colorBlueGray200)">
                  {i18n('Competitions.ScoreInfo.Add.ProductsToTable')}
                </Paragraph>
              </Box>

              <Box display="flex" alignItems="center" gap="xs">
                <IconWrapper>
                  <Icon src={Add} color="var(--colorUIGreen)" />
                </IconWrapper>
                <Paragraph level={4} color="var(--colorBlueGray200)">
                  {i18n('Competitions.ScoreInfo.Add.Tip')}
                </Paragraph>
              </Box>
            </Box>

            <VerticalDivider />

            <Box display="flex" flexDirection="column" gap="small">
              <Box display="flex" alignItems="center" gap="xs">
                <IconWrapper>
                  <Icon src={Remove} color="var(--colorUIRed)" />
                </IconWrapper>
                <Paragraph level={4} color="var(--colorBlueGray200)">
                  {i18n('Competitions.ScoreInfo.Remove.Refunds')}
                </Paragraph>
              </Box>

              <Box display="flex" alignItems="center" gap="xs">
                <IconWrapper>
                  <Icon src={Remove} color="var(--colorUIRed)" />
                </IconWrapper>
                <Paragraph level={4} color="var(--colorBlueGray200)">
                  {i18n('Competitions.ScoreInfo.Remove.RemovedProductsTable')}
                </Paragraph>
              </Box>
            </Box>
          </Box>
        </ModalContent>
      </Modal>
    </>
  );
};

export default TopBar;
